import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const identityVerificationFormSchema = (intl) =>
  z.object({
    identityVerificationStatus: z.string().refine((val) => val === 'verified', {
      message: intl.formatMessage({
        id: 'identity_verification_form.please_verify_identity',
        defaultMessage: 'Please verify your identity.'
      })
    })
  });

export const useIdentityVerificationForm = (intl) => {
  const identityVerificationForm = useForm({
    resolver: zodResolver(identityVerificationFormSchema(intl)),
    defaultValues: {
      identityVerificationStatus: ''
    }
  });

  return { identityVerificationForm };
};
